import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstationcabservice() {



    const cardData = {

keyword: "Pune Outstation Cab Service",

headingDescription:
    "Rising Cab Service provides safe, affordable, and comfortable Pune Outstation Cab Service for family trips, business travel, weekend getaways, pilgrimage tours, and long-distance journeys. We offer a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars with professional and verified drivers. With doorstep pickup from Pune, 24/7 booking support, flexible one-way and round-trip options, and transparent pricing, we ensure a smooth and stress-free outstation travel experience across Maharashtra and India.",

topPlaces: [
    {
        title: "Goa Coastal Drive",
        description:
            "Goa is one of the most in-demand outstation destinations from Pune, famous for its scenic coastal roads, beaches, nightlife, and water sports. Travelers enjoy routes via Kolhapur and the Western Ghats, making it one of the most scenic long-distance cab journeys for holidays and group trips."
    },
    {
        title: "Shirdi Pilgrimage Route",
        description:
            "Shirdi is a highly visited spiritual destination dedicated to Sai Baba. Pilgrims from Pune travel for Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi. The journey is popular for family religious trips and same-day return cab bookings."
    },
    {
        title: "Nashik Wine & Temple Circuit",
        description:
            "Nashik is known for its combination of spirituality and leisure, featuring Trimbakeshwar Jyotirlinga, Panchavati temples, and famous vineyards. It is a perfect destination for both pilgrimage tours and relaxed weekend travel from Pune."
    },
    {
        title: "Mahabaleshwar Scenic Hills",
        description:
            "Mahabaleshwar is a premium hill station known for strawberry farms, lush valleys, viewpoints, and waterfalls. It is one of the most preferred outstation cab destinations for families and honeymoon travelers from Pune."
    },
    {
        title: "Lonavala–Khandala Weekend Escape",
        description:
            "Lonavala and Khandala are the closest hill stations from Pune, popular for monsoon drives, foggy mountains, waterfalls, and viewpoints like Tiger Point and Bhushi Dam. It is the top short outstation cab route."
    },
    {
        title: "Bhimashankar Jyotirlinga Trek Route",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a major pilgrimage and trekking destination offering spiritual darshan and nature experience from Pune."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is a historic city famous for UNESCO World Heritage Sites like Ajanta Caves and Ellora Caves. It is a top long-distance outstation route from Pune for cultural and historical exploration."
    },
    {
        title: "Mumbai City Business & Leisure Trip",
        description:
            "Mumbai is India’s financial capital and a major outstation destination from Pune. Popular attractions include Gateway of India, Marine Drive, Juhu Beach, and corporate hubs, making it ideal for both business and tourism travel."
    },
    {
        title: "Lavasa Hill City Drive",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside views, colorful architecture, boating, and peaceful surroundings. It is a short outstation leisure destination perfect for relaxing weekend trips."
    },
    {
        title: "Tamhini Ghat & Mulshi Nature Route",
        description:
            "Tamhini Ghat and Mulshi are scenic monsoon destinations known for waterfalls, misty valleys, and dam views. It is a popular short outstation cab route for nature lovers and photography trips from Pune."
    }
],



services: [
  {
    name: "Pune Outstation Cab Service",
    description: "Rising Cab Service offers premium Pune Outstation Cab Service designed for safe, comfortable, and stress-free intercity travel. Whether you are planning a business trip, family vacation, weekend getaway, or urgent travel, we provide well-maintained AC vehicles, professional and verified drivers, and 24x7 booking support. Our service ensures timely pickup, smooth highway driving, and complete travel convenience at affordable pricing."
  },
  {
    name: "Outstation Cab Pune",
    description: "Book Outstation Cab in Pune with Rising Cab Service for reliable and comfortable long-distance travel to any city across Maharashtra and India. We offer clean and sanitized vehicles, experienced chauffeurs, flexible pickup and drop locations, and transparent pricing with no hidden charges. Ideal for families, solo travelers, and corporate trips, our service ensures a safe and hassle-free journey every time."
  },
  {
    name: "Pune Outstation Taxi",
    description: "Our Pune Outstation Taxi service is built for long-distance comfort and reliability, offering smooth rides on highways with trained drivers who prioritize safety and punctuality. Whether it’s a short intercity trip or a long journey, we provide AC cars, real-time support, flexible scheduling, and affordable fares. Enjoy a comfortable travel experience with complete peace of mind."
  },
  {
    name: "Outstation Taxi Service Pune",
    description: "Rising Cab Service provides trusted Outstation Taxi Service in Pune for all travel needs including family trips, weekend tours, corporate travel, and pilgrimage journeys. Our service includes well-maintained vehicles, courteous drivers, GPS-enabled rides, and 24x7 availability. We ensure a seamless booking experience with on-time pickup and safe drop at your destination."
  },
  {
    name: "Pune Outstation Car Rental",
    description: "Book Pune Outstation Car Rental with Rising Cab Service for flexible and customized travel solutions. Choose from sedans, SUVs, Innova Crysta, and premium vehicles based on your comfort and group size. We offer hourly, one-way, and round-trip rental options with professional drivers, making your intercity travel convenient, affordable, and fully personalized."
  },
  {
    name: "One Way Outstation Cab Pune",
    description: "Affordable One Way Outstation Cab Pune service designed for drop-only travel without return charges. Perfect for passengers traveling to another city permanently or temporarily, this service includes professional drivers, clean AC vehicles, fixed pricing, and smooth highway travel. Save money while enjoying safe and reliable intercity transportation."
  },
  {
    name: "Pune Outstation Cab Booking",
    description: "Our Pune Outstation Cab Booking system allows instant and easy reservations through a quick process. Customers can choose from multiple vehicle options, compare fares, and confirm bookings within minutes. With 24x7 support, real-time driver tracking, and flexible scheduling, we make your travel planning simple, fast, and stress-free."
  },
  {
    name: "Taxi Service Pune Outstation",
    description: "Rising Cab Service offers dependable Taxi Service Pune Outstation for all types of long-distance travel including business trips, leisure travel, and emergency rides. Our services include trained drivers, comfortable seating, AC vehicles, and safe highway driving. We focus on punctuality, affordability, and customer satisfaction for every journey."
  },
  {
    name: "Best Outstation Cab Pune",
    description: "Choose the Best Outstation Cab Pune service with Rising Cab Service for a premium travel experience that combines safety, comfort, and reliability. We provide top-quality vehicles, experienced chauffeurs, flexible booking options, and 24x7 assistance. Our commitment is to ensure every ride is smooth, enjoyable, and stress-free."
  },
  {
    name: "Cheap Outstation Cab Pune",
    description: "Our Cheap Outstation Cab Pune service is designed for budget-conscious travelers who want affordable yet reliable transportation. We offer low-cost fares without compromising on safety, comfort, or service quality. Enjoy clean vehicles, professional drivers, and transparent pricing for all intercity routes."
  },
  {
    name: "Pune to Outstation Cab",
    description: "Book Pune to Outstation Cab for convenient travel from Pune to any destination across Maharashtra and beyond. We provide flexible pickup points, multiple vehicle categories, and customized travel plans to suit your needs. Enjoy smooth rides, safe driving, and reliable service for all your outstation trips."
  },
  {
    name: "Pune Airport Outstation Taxi",
    description: "Pune Airport Outstation Taxi service offers direct and hassle-free transfers from Pune Airport to any outstation location. With timely pickups, flight monitoring, professional drivers, and comfortable AC cars, we ensure a smooth transition from air travel to road travel without delays or inconvenience."
  },
  {
    name: "Innova Outstation Cab Pune",
    description: "Premium Innova Outstation Cab Pune service is perfect for families and groups who need extra space, comfort, and luxury during long-distance travel. Our Innova Crysta vehicles are well-maintained, spacious, and equipped for smooth highway journeys with experienced drivers ensuring a safe and relaxing ride."
  },
  {
    name: "Sedan Outstation Cab Pune",
    description: "Affordable Sedan Outstation Cab Pune service is ideal for solo travelers, couples, and small families looking for budget-friendly and comfortable intercity travel. We provide fuel-efficient, clean, and well-maintained sedan cars with professional drivers for a smooth and economical journey."
  },
  {
    name: "SUV Outstation Taxi Pune",
    description: "Book SUV Outstation Taxi Pune for group travel and long journeys requiring extra space, power, and comfort. Our SUVs are ideal for families and larger groups, offering ample luggage space, smooth suspension, and experienced drivers for safe and enjoyable highway travel."
  },
  {
    name: "Pune to Mumbai Cab Service",
    description: "Rising Cab Service provides reliable Pune to Mumbai Cab Service for fast, safe, and comfortable intercity travel between two major cities. Enjoy door-to-door pickup, professional drivers, clean AC vehicles, and flexible scheduling for business, leisure, or emergency travel needs."
  },
  {
    name: "Pune to Shirdi Cab Booking",
    description: "Convenient Pune to Shirdi Cab Booking service designed for pilgrims visiting Shri Sai Baba Temple. We offer doorstep pickup, comfortable AC cars, experienced drivers familiar with the route, and flexible timing options to ensure a peaceful and spiritually fulfilling journey."
  },
  {
    name: "One Way Cab Pune",
    description: "Book One Way Cab Pune for affordable drop-only travel to any destination without paying for return trips. Our service includes transparent pricing, professional drivers, clean vehicles, and smooth highway travel, making it a cost-effective option for intercity transportation."
  },
  {
    name: "Pune Airport Outstation Taxi",
    description: "Reliable Pune Airport Outstation Taxi service ensures quick and comfortable transfers from Pune Airport to any city or town. With punctual pickups, flight tracking, AC vehicles, and experienced chauffeurs, we guarantee a seamless travel experience right after landing."
  },
  {
    name: "Cheap Outstation Cabs Pune",
    description: "Cheap Outstation Cabs Pune service provides affordable travel solutions for intercity journeys without compromising on comfort or safety. We offer budget-friendly pricing, clean cars, and professional drivers, making long-distance travel accessible for everyone."
  },
  {
    name: "24x7 Cab Service in Pune",
    description: "Rising Cab Service provides 24x7 Cab Service in Pune ensuring round-the-clock availability for all travel needs including early morning pickups, late-night rides, and emergency bookings. Our support team and drivers are always ready to serve you anytime."
  },
  {
    name: "Pune to Goa Outstation Cab",
    description: "Comfortable Pune to Goa Outstation Cab service for long scenic journeys to Goa beaches. Enjoy safe highway driving, AC vehicles, experienced chauffeurs, and flexible travel plans designed for family vacations, group trips, and leisure travel."
  },
  {
    name: "Pune Tour Package Cab",
    description: "Pune Tour Package Cab service offers customized sightseeing and travel packages across popular destinations. We provide flexible itineraries, professional drivers, and comfortable vehicles to make your tour experience enjoyable, convenient, and memorable."
  },
  {
    name: "Pune Outstation Cabs",
    description: "General Pune Outstation Cabs service provides a wide range of vehicles and travel options for all intercity routes. Whether it’s short trips or long journeys, we ensure safe, affordable, and reliable transportation with 24x7 support."
  },
  {
    name: "Pune Taxi Service for Outstation",
    description: "Reliable Pune Taxi Service for Outstation trips offering comfortable vehicles, experienced drivers, and smooth highway travel. We ensure safe, timely, and affordable intercity transportation for families, professionals, and tourists."
  }
],

tableData: [
  ["Pune Outstation Cab Service", "Outstation Cab Pune"],
  ["Pune Outstation Taxi", "Outstation Taxi Service Pune"],
  ["Pune Outstation Car Rental", "One Way Outstation Cab Pune"],
  ["Pune Outstation Cab Booking", "Taxi Service Pune Outstation"],
  ["Best Outstation Cab Pune", "Cheap Outstation Cab Pune"],
  ["Pune to Outstation Cab", "Pune Airport Outstation Taxi"],
  ["Innova Outstation Cab Pune", "Sedan Outstation Cab Pune"],
  ["SUV Outstation Taxi Pune", "Pune to Mumbai Cab Service"],
  ["Pune to Shirdi Cab Booking", "One Way Cab Pune"],
  ["Pune to Goa Outstation Cab", "Pune Tour Package Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Trusted Pune Outstation Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable outstation cab services from Pune for business trips, family vacations, pilgrimages, sightseeing tours, and long-distance travel."
    },
    {
        WhyChooseheading: "Travel to Popular Destinations Across India",
        WhyChoosedescription: "Our outstation cab service covers Mumbai, Nashik, Shirdi, Mahabaleshwar, Goa, Kolhapur, Nagpur, Hyderabad, Bangalore, Indore, Ahmedabad, and many other destinations."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Options",
        WhyChoosedescription: "Customers can choose one-way transfers, round-trip journeys, multi-day tours, weekend packages, and customized travel plans according to their requirements."
    },
    {
        WhyChooseheading: "Large Fleet for Every Travel Need",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles suitable for individuals, families, and groups."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Travel Experience",
        WhyChoosedescription: "All vehicles are maintained for comfort, cleanliness, and safety, ensuring a smooth journey on every route."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Interstate Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with major highways and tourist routes, ensuring safe and hassle-free travel."
    },
    {
        WhyChooseheading: "Ideal for Family, Corporate, and Pilgrimage Tours",
        WhyChoosedescription: "Rising Cab Service caters to corporate travelers, tourists, families, senior citizens, students, and pilgrimage groups with customized transportation solutions."
    }
]
};

const faqData = [
    {
        question: "What is Pune Outstation Cab Service?",
        answer: "Pune Outstation Cab Service allows customers to hire taxis from Pune for travel to destinations outside the city, including Maharashtra and other states."
    },
    {
        question: "Which destinations are covered under your outstation cab service?",
        answer: "We provide outstation cabs for Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Nagpur, Bangalore, Hyderabad, Ahmedabad, Indore, and many more destinations."
    },
    {
        question: "Can I book a one-way outstation cab from Pune?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "What vehicle options are available for outstation travel?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and luxury vehicles."
    },
    {
        question: "Do you provide outstation cabs for family vacations?",
        answer: "Yes, many families choose our service for holidays, sightseeing tours, weekend getaways, and religious trips."
    },
    {
        question: "Can corporate travelers hire outstation cabs?",
        answer: "Yes, our service is widely used for business meetings, conferences, industrial visits, and executive travel."
    },
    {
        question: "Are Tempo Travellers available for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for group travel, corporate outings, and family functions."
    },
    {
        question: "Can I schedule an outstation cab in advance?",
        answer: "Yes, advance reservations are available and recommended during weekends, holidays, and peak travel seasons."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, customers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I book a Pune Outstation Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amit Kulkarni",
        feedback:
            "Our outstation trip from Pune to Goa was exceptionally comfortable. The vehicle was well-maintained, and the entire journey was managed professionally from departure to return.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Patil",
        feedback:
            "We regularly use Rising Cab Service for family tours and pilgrimage travel. The service is dependable, the drivers are courteous, and every trip has been smooth and enjoyable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Outstation Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-outstation-cab.jpg",
"description": "Book Pune Outstation Cab Service with Rising Cab Service for safe, comfortable, and affordable intercity travel. Enjoy one-way and round-trip taxi service from Pune with AC sedans, SUVs, and Innova cars at best prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-outstation-cab-service"
}
};








    return (
        <div>
<Helmet>
  <title>Pune Outstation Cab Service | Affordable Intercity Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Outstation Cab Service for safe and comfortable intercity travel. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable rates."
/>

<meta
 name="keywords"
 content="pune outstation cab service, outstation cab pune, pune outstation taxi, outstation taxi service pune, pune outstation car rental, one way outstation cab pune, pune outstation cab booking, taxi service pune outstation, best outstation cab pune, cheap outstation cab pune, pune to outstation cab, pune airport outstation taxi, innova outstation cab pune, sedan outstation cab pune, suv outstation taxi pune, Pune Outstation Cab Service, Best Outstation Cab Service in Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneoutstationcabservice;